import { render, staticRenderFns } from "./CanceledOnDispatchDriverTrips.vue?vue&type=template&id=83da1936&"
import script from "./CanceledOnDispatchDriverTrips.vue?vue&type=script&lang=js&"
export * from "./CanceledOnDispatchDriverTrips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports